import styled from "@emotion/styled";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { FlexRow, Link, SiteContainer } from "atoms";
import { useAuth } from "features/auth";

function QAWrapper() {
  const { user } = useAuth();
  const hasSuperAdminRole = user?.roles.includes("superAdmin") ?? false;
  const hasAdminRole =
    hasSuperAdminRole || (user?.roles.includes("admin") ?? false);
  const hasQARole = hasAdminRole || (user?.roles.includes("qa") ?? false);

  const { pathname } = useLocation();

  if (!hasQARole) {
    return <Navigate to="/" replace />;
  }

  return (
    <SiteContainer>
      <QANav>
        <QANavLink
          to="/qa/tickets"
          isActive={pathname.startsWith("/qa/tickets")}
        >
          Tickets
        </QANavLink>
        <QANavLink
          to="/qa/mint-status"
          isActive={pathname.startsWith("/qa/mint-status")}
        >
          Mint Status
        </QANavLink>
      </QANav>
      <Outlet />
    </SiteContainer>
  );
}

const QANav = styled(FlexRow)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.gray60}`,
  marginBottom: "2rem",
})).withComponent("nav");

type WithIsActive = { isActive: boolean };

const QANavLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<WithIsActive>(({ isActive, theme }) => ({
  borderBottom: "3px solid",
  borderColor: isActive ? theme.colors.primary : "rgba(0,0,0,0)",
  padding: "0.5rem 0.8rem",
  textDecoration: "none",
  transform: "translateY(3px)",
}));

export { QAWrapper };
